const env = import.meta.env.VITE_DATADOG_ENV;

export const datadogTags = {
  team: 'customer-service',
  costcenter: 'customer-service',
  appgroup: 'customer-service-cc',
  retention: env?.toLowerCase() === 'production' ? '30' : '7'
};
